export default __webpack_public_path__ + "static/media/picture2.e9bafad9.png";